import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/ui/brand-logo";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-[#fafafa] font-body flex flex-col">
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-brand-navy/95 border-b border-white/10">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/"><BrandLogo dark /></Link>
        <Link to="/" className="text-sm text-slate-200 hover:text-white flex items-center gap-1.5" data-testid="legal-back-home">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </header>

    <main className="flex-1">
      <div className="max-w-3xl mx-auto px-5 py-14">
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight" data-testid="legal-title">{title}</h1>
        <p className="mt-3 text-sm text-slate-400">Last updated: {updated}</p>
        <div className="mt-10 space-y-8 legal-content">{children}</div>
      </div>
    </main>

    <Footer />
  </div>
);

export const LegalSection = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="font-heading font-bold text-xl text-slate-900">{heading}</h2>
    <div className="text-slate-600 leading-relaxed space-y-3 text-[15px]">{children}</div>
  </section>
);
